import {
    addNewRowToTable,
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer, RaikoCardInfoTypeOne, RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoGridThreeColumn,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {GameTeamStatusType, getGameTeamStatus} from "./GameTeamStatusType";
import {css} from "@emotion/css";
import {GameTeamService} from "../../serverService/gameService/GameTeamService";
import AddNewTeam from "../../component/addNewTeam/AddNewTeam";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";

export default function GameTeams({gamePeriodId, gamePeriodTitle}) {
    let page = 0;
    const size = 20;


    const service = new GameTeamService();


    const [gameTeamTitle, setGameTeamTitle] = useState("");
    const _gameTeamTitleFilter = useDebounce(gameTeamTitle, 500);

    const [gameTeamStatus, setGameTeamStatus] = useState(GameTeamStatusType.ALL.id)
    const _gameTeamStatusFilter = useDebounce(gameTeamStatus, 500)

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [gameTeamsData, setGameTeamsData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameTeamsDataFromServer()
        }
    }, [_gameTeamTitleFilter, _gameTeamStatusFilter]);

    function gameTeamsTablePreparation(
        id,
        number,
        title,
        numberOfMembers,
        createdBy,
        createdAt,
        status
    ) {

        let statusChip

        if (status === GameTeamStatusType.ACTIVE.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameTeamStatus(status)} type={RaikoChipTypes.success}/>
        } else if (status === GameTeamStatusType.FORMING.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameTeamStatus(status)} type={RaikoChipTypes.warning}/>
        } else if (status === GameTeamStatusType.DISBANDED.id || GameTeamStatusType.DISQUALIFIED.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameTeamStatus(status)} type={RaikoChipTypes.error}/>
        }


        return {
            id,
            number,
            title,
            numberOfMembers,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
            status: statusChip,
            statusPlace: status
        }

    }

    function getGameTeamsDataFromServer() {
        setTableLoading(true)
        service.getTeamList(gamePeriodId, page, size, _gameTeamTitleFilter, _gameTeamStatusFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setGameTeamsData([])
                response.data.map((item, index) => {
                    setGameTeamsData(prevState => [
                        ...prevState,
                        gameTeamsTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.numberOfMembers,
                            item.createdBy,
                            item.createdAt,
                            item.status
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleDeleteAllFilters() {
        setGameTeamStatus(GameTeamStatusType.ALL.id)
    }

    function handlePaginationChange(newPage) {
        page = newPage
        getGameTeamsDataFromServer()
    }

    //
    const [openAddNewTeamDialog, setOpenAddNewTeamDialog] = useState(false);

    function handleOpenAddNewTeamDialog() {
        setOpenAddNewTeamDialog(true)
    }

    function handleCloseAddNewTeamDialog() {
        setOpenAddNewTeamDialog(false)
    }

    //

    function handleAddNewGameTeamRow(item) {
        const _items = addNewRowToTable(
            gameTeamsTablePreparation(
                item.id,
                1,
                item.title,
                item.numberOfMembers,
                item.createdBy,
                item.createdAt,
                item.status
            ),
            gameTeamsData
        );
        setGameTeamsData(_items)
    }


    const navigate = useNavigate()

    function ShowGameTeamDetails(gameTeamId) {

        const team = gameTeamsData.find(
            (item) => item.id === Number(gameTeamId)
        );
        navigate(
            RouteHelper.GameTeamDetails.globalUrl
                .replace(":gamePeriodId", gamePeriodId)
                .replace(":gameTeamId", gameTeamId),
            {
                state: {
                    gamePeriodTitle: gamePeriodTitle,
                    gameTeamTitle: team?.title || ""
                },
                replace: false
            }
        );
    }

    return (
        <>
            <RaikoDefaultDialogPage
                pageTitle={""}
                onClose={handleCloseAddNewTeamDialog}
                open={openAddNewTeamDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewTeam
                    gamePeriodId={gamePeriodId}
                    handleCloseDialog={handleCloseAddNewTeamDialog}
                    handleAddNewTeamToTable={handleAddNewGameTeamRow}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"تیم ها"}
                        amount={numberOfItems}
                        hasSelectDisplayType
                        selectDisplayType={selectDisplayType}
                        setSelectDisplayType={setSelectDisplayType}
                        hasCreateNewItem
                        handleCreateNewItem={handleOpenAddNewTeamDialog}
                    />
                    <RaikoTableSearchContainer
                        labelText={"عنوان تیم"}
                        value={gameTeamTitle}
                        setValue={setGameTeamTitle}
                        hasFilter
                        filterStatus={
                            gameTeamStatus.length > 0 &&
                            gameTeamStatus !== GameTeamStatusType.ALL.id
                        }
                        handleDeleteAllFilters={handleDeleteAllFilters}
                    >
                        <RaikoGridOneColumn>
                            <RaikoCustomSelect
                                labelText={"وضعیت"}
                                value={gameTeamStatus}
                                setValue={setGameTeamStatus}
                                items={[
                                    raikoCustomSelectItemGenerator(GameTeamStatusType.ALL.id, GameTeamStatusType.ALL.title),
                                    raikoCustomSelectItemGenerator(GameTeamStatusType.ACTIVE.id, GameTeamStatusType.ACTIVE.title),
                                    raikoCustomSelectItemGenerator(GameTeamStatusType.FORMING.id, GameTeamStatusType.FORMING.title),
                                    raikoCustomSelectItemGenerator(GameTeamStatusType.DISBANDED.id, GameTeamStatusType.DISBANDED.title),
                                    raikoCustomSelectItemGenerator(GameTeamStatusType.DISQUALIFIED.id, GameTeamStatusType.DISQUALIFIED.title),
                                ]}
                            />
                        </RaikoGridOneColumn>
                    </RaikoTableSearchContainer>
                    <RaikoCustomTable
                        header={gameRegistrationListHeader}
                        data={gameTeamsData}
                        isLoading={tableLoading}
                        pageCount={pageCount}
                        selectDisplayType={selectDisplayType}
                        handlePaginationChange={handlePaginationChange}
                        rowClicked={ShowGameTeamDetails}
                    >
                        <RaikoGridThreeColumn className={css`padding: 3px`}>
                            {
                                gameTeamsData.map((item, index) => {
                                    return <RaikoCardInfoTypeOne
                                        key={index}
                                        title={item.title}
                                        status
                                        statusType={
                                            item.statusPlace === GameTeamStatusType.DISQUALIFIED.id || item.statusPlace ===
                                            GameTeamStatusType.DISBANDED.id ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                item.statusPlace === GameTeamStatusType.FORMING.id ?
                                                    RaikoCardInfoTypeOneStatusTypes.WARNING : RaikoCardInfoTypeOneStatusTypes.SUCCESS

                                        }
                                        statusText={
                                            item.statusPlace === GameTeamStatusType.ACTIVE.id ? GameTeamStatusType.ACTIVE.title :
                                                item.statusPlace === GameTeamStatusType.FORMING.id ? GameTeamStatusType.FORMING.title :
                                                    item.statusPlace === GameTeamStatusType.DISBANDED.id ? GameTeamStatusType.DISBANDED.title :
                                                        GameTeamStatusType.DISQUALIFIED.title
                                        }
                                        items={[
                                            RaikoCardInfoTypeOneItemGenerator("تعداد بازیکن", item.numberOfMembers),
                                            RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy),
                                            RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt),
                                        ]}
                                        onClick={()=>{
                                            ShowGameTeamDetails(item.id)
                                        }}

                                    />
                                })
                            }

                        </RaikoGridThreeColumn>

                    </RaikoCustomTable>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </>

    )
}

const gameRegistrationListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان تیم"
    },
    {
        id: "numberOfMembers",
        label: "تعداد بازیکن"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "status",
        label: "وضعیت"
    },
]